"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorButtonContextMenu = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
const ColorButtonContextMenu = (0, _styled.default)("div")`
    color: ${(0, _designTokensReact.color)("color--text--neutral--strong")};
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(0, _designTokensReact.color)("color--background--surfaces--work")};
    border: none;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    width: auto;
    height: 48px;
    position: absolute;
    bottom: -50px;
    left: -41px;
    z-index: 2;
    padding: 0 8px;
    cursor: pointer;
`;
exports.ColorButtonContextMenu = ColorButtonContextMenu;
//# sourceMappingURL=ColorButtonContextMenu.js.map